export const checkForResultListForContentRecWidget = () => {
    var cache = {
        $resultListIsPresent: $(".result-list-is-present"),
        $mobileFirst: $(".mobile-first"),
    };
    (cache.$resultListIsPresent.length == 0) ? cache.$mobileFirst.removeClass("mobile-first"): cache.$resultListIsPresent.parents(".mobile-first").removeClass("mobile-first");
};
